<template>
	<v-menu
		bottom 
		offset-y 
		:key  					= "'menu' + ref_to_component"
		:close-on-content-click = "options.close_on_content"
				
	>
		<template v-slot:activator = "{ on : menu }">
			<v-tooltip top>
				<template v-slot:activator = "{ on : tooltip}">
					<span
			    		v-on = "{...tooltip, ...menu}"	
			    		v-if = "!info.btn"
		    		>			  

		    			<v-icon
		    				:large 	 = "!info.icon_size"
		    				:x-small = "info.icon_size == 'x-small'" 
		    				:small 	 = "info.icon_size == 'small'" 

		    				v-show = "info.icon"
		    			>
		    				{{ info.icon }}
		    			</v-icon>
		    			<br v-if = "!info.skip_br">
		    			<span 
			      			class  = "caption mb-0"	
		    				v-show = "info.tag"			      				      	
				      	>
				      		{{ info.tag  }}
				      		<!-- && $ml.get(info.tag) ? $ml.get(info.tag) : info.tag -->
				      	</span> <!--  d-flex justify-center -->
			    	</span>
			    	<v-btn
			    		v-else-if 	= "info.btn"
			    		v-on 		= "{...tooltip, ...menu}"	
			    		:small 		= "info.btn_size == 'small'" 
			    		:x-small	= "info.btn_size == 'x-small'" 
			    		:color 		= "info.color_btn"
						v-show 		= "show_menu_component"

		    		>			  

		    			<v-icon
		    				:large 	 = "!info.icon_size"
		    				:x-small = "info.icon_size == 'x-small'" 
		    				:small 	 = "info.icon_size == 'small'" 

		    				v-show = "info.icon"
		    			>
		    				{{ info.icon }}
		    			</v-icon>
		    			<br v-if = "!info.skip_br">
		    			<span 
			      			class  = "caption mb-0"	
		    				v-show = "info.tag"			      				      	
				      	>
				      		{{ info.tag  }} :
				      		{{  selected }}
				      		<!-- && $ml.get(info.tag) ? $ml.get(info.tag) : info.tag -->
				      		<!-- $ml.get(selected) ? $ml.get(selected) : -->

				      	</span> <!--  d-flex justify-center -->
			    	</v-btn>
				</template>
				<span 
	      			class  = "caption mb-0"	
					v-show = "info.tag"			      				      	
		      	>
		      		{{ actions_menu("render_name_tag", info)}}
		      		
		      	</span>
			</v-tooltip>
			<span>
				
			</span>
		</template>
		<v-list 
			dense
		>
			<v-list-item-group 
              	dense
              	:multiple  	= "options.multiple"
              	v-if 		= "options.type == 'select'"
              	v-model 	= "selecteds"
            >
              	<template v-for = "(item_list, index_list) of list">
                
		            <v-list-item               
	                	dense
	                	:Key 	   = "index_list"
	                	v-if       = "item_list"                   
	                	@click     = "actions_menu(options.action, item_list, index_list)"
	                
	              	>             
		              	<template v-slot:default="{ active }">
	                  		<v-list-item-action 
	                  			v-if = "options.multiple"
	                  		>
			                    <v-checkbox
			                      color 			 = "primary"
			                      :input-value 		 = "active"
			                    ></v-checkbox>
		                  	</v-list-item-action> 
		                  	<v-list-item-content 
		                  		class = "pa-0 ma-0"
		                  	>
		                    	<v-list-item-title> 
		                    		{{ render_texts(item_list) }} 
		                   		</v-list-item-title>
		                  	</v-list-item-content>
	                	</template>              
	            	</v-list-item>
	            </template>
	        </v-list-item-group>
	    </v-list>
	</v-menu>
</template>
<script>
	
	export default{
		name  : 'menus',
		props : [
			'info_to_component', // info to config default tag
			'options_to_component', // options of menu
			'list_to_component', // if content a list
			'ref_to_component',
			'setting_to_component',
			'selected_to_component', // tag1
			'show_menu_component'
			

		],
		/*
			info_to_component : {
				icon : mdi-
				tag  : name 
				updated : reactive list
			}
			options_to_component :{
				
				multiple    : bool
				type 		: select |
				item_text  	: optional 
				action 		: sel_tag |
				close_on_content : false |
			}
			list_to_component : []
		*/
		data : () => ({
			info 		: {},
			list 		: [],
			list_icon   : [],
			options 	: {},
			info_fields : [],		
			selecteds   : [],	
			selected 	: '',

		}), // data

		created(){

			if (this.info_to_component && this.options_to_component) {
				this.render_info(this.info_to_component, this.options_to_component);
			}else{
				console.warn("Required options and info for menu ");
			}
			if (this.selected_to_component) {
				this.actions_menu('render_selected', this.selected_to_component)
			}
		}, // created
		watch : {
			info_to_component: function(val){
				if (val.tag != this.info.tag || val.icon != this.info.icon) {		
					this.render_info(val);
				}
				if (val.updated) {
					if (this.list_to_component) {					
					// console.log("LIST UPDATE ", this.list_to_component)	
						this.list = this.list_to_component;						
					}
				}
			}, // info to component
			selected_to_component : function(val){
				if (val) {
					this.actions_menu('render_selected', val);
				}
			}, 
		}, // watch


		methods : {
			actions_menu(act, item, opt){
				// console.log("actions_menu action ", act, " \n item ", item ," \n option ", opt, this.info)
				if (act == 'sel_tag') {									
					this.$emit('receive_info', item);				
				}
				if (act == 'render_selected') {
					this.selected = item;
				}
				if (act == "render_name_tag") {	
					if (item) {

						if (item.updated && ["smart_event", "data"].includes(item.updated)) {
							return item.tag; // info
						}else{
							return this.$ml.get(item.tag) || item.tag; //  info
						}
					}
				}
			}, // actions_menu

			render_info(item, option){
				if (item) {
					this.info = {...item}; // head menu
				}
					// console.log("meus ", item, option)
				if (option) { 
					this.options = option; // options of menu 
				}
				if (this.list_to_component) { // list for menu
					// console.log("list menus ", this.list_to_component)
					this.list = this.list_to_component;
				}
				
				
			}, // render info

			render_texts(item){
				if (!this.options.item_text) {
					return item;				
				}else{
            		if (this.options && this.options.item_text && item[this.options.item_text] && this.info && !["smart_event", "data"].includes(this.info.updated) && this.$ml.get(item[this.options.item_text])) {
            			return	this.$ml.get(item[this.options.item_text]);
            		}else if (this.options && this.options.item_text && item[this.options.item_text]) {
            			return item[this.options.item_text] 
            		}
            		return item;
            		
				}
			}, // render texts
		}, //methods
	};
</script>